export const COUNTRY_OPTIONS = {
  AR: 'Argentina',
  BO: 'Boliviana',
  BR: 'Brasileña',
  CL: 'Chilena',
  CO: 'Colombiana',
  CR: 'Costarricense',
  CU: 'Cubana',
  DO: 'Dominicana',
  EC: 'Ecuatoriana',
  SV: 'Salvadoreña',
  GT: 'Guatemalteca',
  HN: 'Hondureña',
  MX: 'Mexicana',
  NI: 'Nicaragüense',
  PA: 'Panameña',
  PY: 'Paraguaya',
  PE: 'Peruana',
  PR: 'Puertorriqueña',
  UY: 'Uruguaya',
  VE: 'Venezolana',
} as const;

export type CountryOptionKey = keyof typeof COUNTRY_OPTIONS;
export type CountryOptionValue = (typeof COUNTRY_OPTIONS)[CountryOptionKey];

export const translateCountry = (country: string | undefined | null) => {
  if (country && country in COUNTRY_OPTIONS)
    return COUNTRY_OPTIONS[country as CountryOptionKey];
  return country;
};

export const PROFESSION_OPTIONS = [
  'Abogado',
  'Arquitecto',
  'Administrador',
  'Comerciante',
  'Contador',
  'Diseñador',
  'Enfermero',
  'Ingeniero',
  'Médico',
  'Profesor',
  'Psicólogo',
  'Vendedor',
  'Obrero',
  'Estudiante',
  'Otro',
] as const;

export const MARITAL_STATUS_OPTIONS = {
  SINGLE: 'Soltero',
  MARRIED: 'Casado',
  MARRIED_COMMUNITY: 'Casado en Sociedad Conyugal',
  MARRIED_SEPARATION: 'Casado con Separación de Bienes',
  MARRIED_GAINS: 'Casado con Participación en los Gananciales',
  DIVORCED: 'Divorciado',
  WIDOWED: 'Viudo',
  SEPARATED: 'Separado',
  COHABITING: 'Unión Libre',
};

export type MaritalStatusOptionKey = keyof typeof MARITAL_STATUS_OPTIONS;
export type MaritalStatusOptionValue =
  (typeof MARITAL_STATUS_OPTIONS)[MaritalStatusOptionKey];

export const translateMaritalStatus = (
  maritalStatus: string | undefined | null,
) => {
  if (maritalStatus && maritalStatus in MARITAL_STATUS_OPTIONS)
    return MARITAL_STATUS_OPTIONS[maritalStatus as MaritalStatusOptionKey];
  return maritalStatus;
};

export const ROLE_OPTIONS = [
  'Gerente de finanzas',
  'Gerente general',
  'Gerente de operaciones',
  'Gerente de ventas',
  'Jefe de finanzas',
  'Jefe de operaciones',
  'Ejecutivo',
  'Analista',
  'Asistente',
  'Otro',
] as const;

export type RoleOptionKey = keyof typeof ROLE_OPTIONS;
export type RoleOptionValue = (typeof ROLE_OPTIONS)[RoleOptionKey];

export const translateRole = (role: string | undefined | null) => {
  if (role && role in ROLE_OPTIONS) return ROLE_OPTIONS[role as RoleOptionKey];
  return role;
};
